<template>
  <div class="brief-container">
    <h2>项目简介</h2>
    <div class="brief-content">
      <p>
        在党的二十大胜利召开的新起点上，习近平总书记的重要报告为学界构建中国话语和中国叙事体系指明了方向、提供了理据。为了加快构建中国话语和叙事体系，在全球格局与历史视野中重新认识中国话语与世界的内外关联和文明互鉴，推进交叉学科学术研究、人才培养与国际传播，为中国话语的全球化表达、区域化表达、分众化表达提供知识动能，在上海外国语大学、上海全球治理与区域国别研究院的大力支持下，<strong>中国话语与世界文学研究中心</strong>于2022年正式揭牌成立。
      </p>
      <!-- <div class="video-content">
        图片
      </div> -->
      <p>
        中国话语与世界文学研究中心将以习总书记提出的<strong>“构建中国特色哲学社会科学三大体系”</strong>重大战略目标为指导，在世界文学视域下，坚持中国话语主体性立场，以中华为根，以文学为尺，丈量世界思想，拓展精神疆域，弘扬中华优秀传统文化，打造中国文化走出去协同创新话语体系。自研究中心筹建以来，汇聚力量，整合资源，在多层面积极开展工作，助推文学发展与中外文化交流。
      </p>
      <p>
        <strong>一、学术创新，开拓研究领域。</strong>研究中心以完成国家级、省部级等重大前沿研究课题、孵化标志性成果为导向，构建融通中外的话语体系。2020年，由研究中心主任张帆教授担任首席专家的教育部哲学社科研究重大课题攻关项目“‘中国故事’在世界文学中的征引阐释及启示研究”立项开题。课题团队围绕经典中国故事在世界经典文学中的经典演绎展开系统的研究，探讨中国故事在世界文学中的征引阐释、传播路径、流变谱系与范式表征，掘发中国故事的当代价值与世界影响，为讲好中国故事、传播优秀中国文化提供坚实的学理依据。短短两年，课题团队已在A&HCI与CSSCI期刊发表高水平论文14篇。
      </p>
      <p>
        <strong>二、学术交流，促进学术传播。</strong>研究中心积极举办各类学术活动，为持续的学术交流提供保障，助力学者凝聚共识、激发与扩散思想。研究中心举办并参与学术讲座、研讨会和专题报告已达50余次，受邀嘉宾包括来自海内外不同高校与研究领域的专家学者。研究中心学术交流活动注重中外文学译介、传播与关系研究，聚焦中国文化走出去，重视与作家、译者、学者、文化界与出版界的交流与沟通，关注青年学人的发展，为其提供学习与发声机会，助力学术成长。
      </p>
      <p>
        <strong>三、团队建设，打造人才梯队。</strong>研究中心以服务国家文化战略和外国语言文学“双一流”高校建设目标为宗旨，将组建高端创新团队，引进海内外高层次人才，形成具有学术竞争力的中青年教学科研团队。目前，研究中心成员先后入选国家哲学社会科学“万人计划”领军人才、中宣部文化名家暨“四个一批”人才、中国博士后国际交流计划引进项目、上海市“超级博士后”等人才项目；主持国家级与省部级科研课题5项。
      </p>
      <p>
        <strong>四、图书出版，推进学科建设。</strong>研究中心在中国话语与世界文学领域凸显特色，以出版文库与辑刊形成长效的学术生产机制和凝聚效应。研究中心已与国内多家知名学术出版社达成合作关系，由张帆主任主编的“德语经典文学研究丛书”（商务印书馆）、“德语上海小说翻译与研究丛书”（世界知识出版社）、“中国文学海外译介研究丛书”（上海大学出版社）、“中国话语与世界文学研究文库”（商务印书馆）正在陆续出版中，目前出版15部，即将出版14部。
      </p>
      <p>
        <strong>五、技术革新，引领数字人文。</strong>研究中心建成运行世界范围首个“世界文学‘中国故事’文献传播与研究数据库”，开发传播地图、关系图、统计图三大可视化平台。数据库建设集结国内十余所高校科研力量，涵盖英语、德语、法语、俄语等33个语种。在团队160余人的通力合作下，耙梳、分析世界文学作品和研究文献，发掘并翻译仍处研究盲区的一手资料，已搜集数据近七千条，将打造上外特色教学资源平台和对学界、公众开放的共享式学术交流平台。
      </p>
      <p>
        <strong>六、经世致用，服务国家战略。</strong>研究中心坚持对标国家战略，致力构建经世致用的学术体系，既在学术知识领域保持先进水平，也为探索中国文化输出战略提供原创理论、实证支撑和规划参考。研究中心团队结合研究课题与学术成果，撰写提交多篇高规格咨政报告，踊跃向相关部门进言献策，提升学术与理论研究的社会与应用价值，助力增强中国的文化软实力与国际话语权。
      </p>
      <p>
        中国话语与世界文学研究领域的新气象，顺应新时代变局的发展需求，展现了本土优秀文化的域外拓展。未来研究中心将持续促进<strong>“学术创新、学术交流、学术品牌、人才培养、学科建设、数字人文、经世致用、话语传播”</strong>八大领域的协同发展，致力于将研究中心建设成国内有影响力、特色鲜明的学术基地与传播阵地。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  props: {

  },
  components: {

  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style lang="less" scoped>
.brief-container {
  h2 {
    font-weight: 600;
    font-size: 28px;
    line-height: 45px;
    text-align: center;
    color: #212529;
    margin-bottom: 30px;
  }
  p {
    font-size: 16px;
    text-indent: 32px;
    color: #333;
    line-height: 32px;
  }
  .video-content {
    text-align: center;
    margin: 14px 0;
  }
}

@media screen and (max-width: 768px) {
  .brief-container {
    p {
      font-size: 14px;
      text-indent: 28px;
      color: #333;
      line-height: 28px;
    }
  }
}
</style>